import React, { useEffect, useState, useCallback } from "react";
import Header from "../Components/Header";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";
import { FileText, Eye, Download, X, Inbox, RefreshCw } from "lucide-react";

const API = process.env.REACT_APP_API_URL;

function formatTutar(t) {
  const n = Number(t);
  if (!isFinite(n)) return "-";
  return n.toLocaleString("tr-TR", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + " ₺";
}

export default function Faturalarim() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [faturalar, setFaturalar] = useState([]);
  const [aktif, setAktif] = useState(null); // görüntülenen fatura {id}

  const token = Cookies.get("token");

  const yukle = useCallback(async () => {
    if (!token) {
      window.location.href = "/login";
      return;
    }
    setLoading(true);
    setError("");
    try {
      const res = await fetch(`${API}/api/faturalar/get`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ token }),
      });
      const data = await res.json();
      if (data.m === "basarili") {
        setFaturalar(Array.isArray(data.data) ? data.data : []);
      } else {
        setError("Faturalar yüklenemedi. Lütfen tekrar deneyin.");
      }
    } catch (e) {
      setError("Bağlantı hatası. Lütfen tekrar deneyin.");
    } finally {
      setLoading(false);
    }
  }, [token]);

  useEffect(() => {
    yukle();
  }, [yukle]);

  // Modal açıkken body scroll kilidi + ESC ile kapat
  useEffect(() => {
    if (!aktif) return;
    const onKey = (e) => e.key === "Escape" && setAktif(null);
    document.addEventListener("keydown", onKey);
    const prev = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      document.removeEventListener("keydown", onKey);
      document.body.style.overflow = prev;
    };
  }, [aktif]);

  const pdfUrl = (id) => `${API}/api/faturalar/pdf/${id}?token=${encodeURIComponent(token)}`;

  return (
    <>
      <Header />
      <div style={{ minHeight: "70vh", background: "#f6f8fb", padding: "32px 16px" }}>
        <div style={{ maxWidth: 960, margin: "0 auto" }}>
          <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 24, flexWrap: "wrap", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <div style={{ background: "#10b981", color: "#fff", width: 44, height: 44, borderRadius: 12, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <FileText size={24} />
              </div>
              <div>
                <h1 style={{ margin: 0, fontSize: 24, fontWeight: 700, color: "#0f172a" }}>Faturalarım</h1>
                <p style={{ margin: 0, color: "#64748b", fontSize: 14 }}>Adınıza kesilen faturaları buradan görüntüleyebilirsiniz.</p>
              </div>
            </div>
            <button onClick={yukle} disabled={loading} style={btnSecondary}>
              <RefreshCw size={16} style={{ marginRight: 6 }} /> Yenile
            </button>
          </div>

          {loading ? (
            <div style={card}><p style={{ textAlign: "center", color: "#64748b", margin: "40px 0" }}>Yükleniyor…</p></div>
          ) : error ? (
            <div style={card}>
              <p style={{ textAlign: "center", color: "#ef4444", margin: "24px 0 16px" }}>{error}</p>
              <div style={{ textAlign: "center" }}>
                <button onClick={yukle} style={btnPrimary}>Tekrar dene</button>
              </div>
            </div>
          ) : faturalar.length === 0 ? (
            <div style={card}>
              <div style={{ textAlign: "center", color: "#94a3b8", padding: "40px 0" }}>
                <Inbox size={48} style={{ marginBottom: 12 }} />
                <p style={{ margin: 0, fontSize: 16 }}>Henüz görüntülenecek faturanız bulunmuyor.</p>
              </div>
            </div>
          ) : (
            <div style={{ ...card, padding: 0, overflow: "hidden" }}>
              {/* Masaüstü tablo başlığı */}
              <div style={rowHead}>
                <span style={{ flex: 2 }}>Tarih</span>
                <span style={{ flex: 2 }}>Dönem</span>
                <span style={{ flex: 2, textAlign: "right" }}>Tutar</span>
                <span style={{ flex: 3, textAlign: "right" }}>İşlem</span>
              </div>
              {faturalar.map((f) => (
                <div key={f.id} style={row}>
                  <span style={{ flex: 2, fontWeight: 600, color: "#0f172a" }}>{f.tarih || "-"}</span>
                  <span style={{ flex: 2, color: "#475569" }}>{f.ay || "-"}</span>
                  <span style={{ flex: 2, textAlign: "right", fontWeight: 600, color: "#0f172a" }}>{formatTutar(f.tutar)}</span>
                  <span style={{ flex: 3, textAlign: "right", display: "flex", gap: 8, justifyContent: "flex-end", flexWrap: "wrap" }}>
                    {f.goruntulenebilir ? (
                      <>
                        <button onClick={() => setAktif(f)} style={btnPrimary}>
                          <Eye size={16} style={{ marginRight: 6 }} /> Görüntüle
                        </button>
                        <a href={pdfUrl(f.id)} target="_blank" rel="noopener noreferrer" style={btnSecondary}>
                          <Download size={16} style={{ marginRight: 6 }} /> İndir
                        </a>
                      </>
                    ) : (
                      <span style={{ color: "#94a3b8", fontSize: 13, alignSelf: "center" }}>Görüntülenemiyor</span>
                    )}
                  </span>
                </div>
              ))}
            </div>
          )}
        </div>
      </div>

      {/* PDF görüntüleme modalı */}
      {aktif && (
        <div style={overlay} onClick={() => setAktif(null)}>
          <div style={modal} onClick={(e) => e.stopPropagation()}>
            <div style={modalHead}>
              <span style={{ fontWeight: 600, color: "#0f172a" }}>
                Fatura {aktif.tarih ? "· " + aktif.tarih : ""}
              </span>
              <button onClick={() => setAktif(null)} style={iconBtn} aria-label="Kapat">
                <X size={20} />
              </button>
            </div>
            <iframe
              title="Fatura"
              src={pdfUrl(aktif.id)}
              style={{ flex: 1, width: "100%", border: "none" }}
            />
          </div>
        </div>
      )}

      <Footer />
    </>
  );
}

const card = { background: "#fff", borderRadius: 16, boxShadow: "0 1px 3px rgba(0,0,0,0.08)", padding: 20 };
const rowHead = { display: "flex", alignItems: "center", padding: "14px 20px", background: "#f1f5f9", color: "#64748b", fontSize: 13, fontWeight: 600, textTransform: "uppercase", letterSpacing: 0.3 };
const row = { display: "flex", alignItems: "center", padding: "14px 20px", borderTop: "1px solid #eef2f7", fontSize: 15 };
const btnPrimary = { display: "inline-flex", alignItems: "center", background: "#10b981", color: "#fff", border: "none", padding: "8px 14px", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", textDecoration: "none" };
const btnSecondary = { display: "inline-flex", alignItems: "center", background: "#fff", color: "#0f172a", border: "1px solid #cbd5e1", padding: "8px 14px", borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: "pointer", textDecoration: "none" };
const overlay = { position: "fixed", inset: 0, background: "rgba(15,23,42,0.6)", zIndex: 100000, display: "flex", alignItems: "center", justifyContent: "center", padding: 16 };
const modal = { background: "#fff", borderRadius: 12, width: "min(900px, 100%)", height: "min(90vh, 100%)", display: "flex", flexDirection: "column", overflow: "hidden", boxShadow: "0 20px 60px rgba(0,0,0,0.3)" };
const modalHead = { display: "flex", alignItems: "center", justifyContent: "space-between", padding: "12px 16px", borderBottom: "1px solid #eef2f7" };
const iconBtn = { background: "transparent", border: "none", cursor: "pointer", color: "#64748b", display: "flex" };
